import styled, { css }  from 'styled-components';
import { getSize, SizeTypes } from '../utils/getSize';
import {imageSize, media} from '../utils/variables';

interface ImageProps {
  width?: string | number;
  height?: string | number;
  extent?: SizeTypes;
  padding?: number;
  rotate?: number;
  bell?: boolean;
  alt?: string;
  active?: boolean;
}

export const Image = styled.img<ImageProps>`
  
  opacity: ${({ active }) => (active ? `1` : `0.7`)};
  padding: ${({ padding }) => (padding ? `${padding}px` : ``)};
  height: ${({ height }) => (height ? `${height}` : ``)};
  transform: rotate(${({ rotate }) => (rotate ? `${rotate}deg` : '0')});
  cursor: ${({ bell }) => (bell ? 'pointer' : 'unset')};
  width: ${({ extent }) =>
    extent ? `${getSize(extent, imageSize)}` : 'unset'};
  alt: ${({alt}) => (alt ? `${alt}` : "")}}

    ${({ width }) => width
    ? css`
        width: ${width};
      `
    : ``
  }

  :hover {
    opacity: 1;
  }
    
  ${media.mobile} {
    height: ${({bell}) => bell && '16px'};
    width: ${({bell}) => bell && '16px'};
    vertical-align: center;
  }

  ${media.tablet} {
    height: ${({bell}) => bell && '16px'};
    width: ${({bell}) => bell && '16px'};
    vertical-align: center;
  }
`;
